


































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapGetters, mapState } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    convertDateLocalValeurT,
    convertDateUTCValeurT,
    dateIsBetween,
    dateNow,
    formatDateHoursMinutes,
    getDayMonthYear
} from '@/utils/helpers'
import { code_publishable_message } from '@/types/PublishableMessage'
import { etat_transfered_datas, etat_validated_datas, opened_datas, PublicationInterface } from '@/types/Publication'
import { Ability } from '@/types/Ability'

@Component({
    computed: {
        ...mapState('publication', ['publications', 'loading_publications']),
        ...mapGetters('publication', ['get_publications_inscriptions']),
        ...mapState('publishableMessage', ['publishableMessages']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon
    }
})
export default class AccesFormulaireInscription extends Vue {
    convertDateLocalValeurT = convertDateLocalValeurT
    Ability = Ability

    publication_template: PublicationInterface = {
        name: '',
        id: 0,
        session_id: 0,
        entity_id: 0,
        entity_type: '',
        publishable_id: 0,
        opened: 0,
        datas_transfered: 0,
        datas_validated: 0,
        dossier_inscriptions_count: 0,
        start_at: '',
        end_at: '',
        publishable: {
            id: 0,
            code: '',
            name: '',
            display_group: '',
            display_interface: '',
            route: '',
            entity_type: '',
            entity_properties_to_check: {
                validated: 0
            },
            libelle_check: {
                datas_ok: '',
                datas_ko: '',
                datas_erreur_transfert: ''
            },
            ordre: 0
        },
        visibility_start_at: '',
        visibility_end_at: ''
    }

    publications_inscriptions: PublicationInterface[] = []
    publication_select: PublicationInterface = JSON.parse(JSON.stringify(this.publication_template))

    showModaleEditionAcces = false
    inverse_switch = false
    error_dates: any = null

    @Watch('publications')
    loadDatasResultats() {
        this.initDatas()
    }

    /**
     * État de validation des données
     * @param {PublicationInterface} publication - Publication
     * @returns { libelle: string; icon: string; color: string; state: boolean } Données à afficher sur l'interface
     */
    getEtatValidation(publication: PublicationInterface): {
        libelle: string,
        icon: string,
        color: string,
        state: boolean
    } {
        // Résultats ni transférés ni validés
        if (publication.datas_validated === etat_validated_datas.DATAS_VALIDATED_NON) {
            return {
                libelle: publication.publishable.libelle_check.datas_ko,
                icon: 'times',
                color: 'secondary',
                state: false
            }
        }
        // Résultats non transférés mais validés
        if (
            (publication.datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_NON ||
                publication.datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_EN_COURS) &&
            publication.datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI
        ) {
            return {
                libelle: publication.publishable.libelle_check.datas_ok,
                icon: 'repeat-alt',
                color: 'info',
                state: false
            }
        }
        // Transfert EN ERREUR
        if (
            publication.datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_ERREUR &&
            publication.datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI
        ) {
            return {
                libelle: publication.publishable.libelle_check.datas_erreur_transfert,
                icon: 'times',
                color: 'danger',
                state: false
            }
        }
        // Résultats non transférés mais validés
        if (
            publication.datas_transfered === etat_transfered_datas.DATAS_TRANSFERED_NON &&
            publication.datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI
        ) {
            return {
                libelle: publication.publishable.libelle_check.datas_ok,
                icon: 'repeat-alt',
                color: 'info',
                state: false
            }
        }
        // Résultats validés
        if (
            publication.datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI &&
            publication.datas_validated === etat_validated_datas.DATAS_VALIDATED_OUI
        ) {
            return {
                libelle: publication.publishable.libelle_check.datas_ok,
                icon: 'check',
                color: 'success-bold',
                state: true
            }
        }
        return { libelle: '-', icon: '', color: 'secondary', state: false }
    }

    /**
     * État des programmations
     * @param {PublicationInterface} publication - Publication
     * @param {string} target - Cible programmation ('access', 'visibility')
     * @returns {libelle: string; color: string; state: boolean} Données à afficher sur l'interface
     */
    getProg(
        publication: PublicationInterface,
        target: 'access' | 'visibility' = 'access'
    ): {
            libelle: string[],
            color: string,
            state: boolean
        } {
        let start_at: Date | number | string = publication.start_at
        let end_at: Date | number | string = publication.end_at
        if (target === 'visibility') {
            start_at = publication.visibility_start_at
            end_at = publication.visibility_end_at
        }
        if (!start_at && !end_at) {
            return { libelle: ['-'], color: 'secondary', state: false }
        } else {
            const is_between: boolean = dateIsBetween(dateNow(), start_at, end_at, [])
            return {
                libelle: [
                    `${getDayMonthYear(start_at)} (${formatDateHoursMinutes(start_at)})`,
                    `${getDayMonthYear(end_at)} (${formatDateHoursMinutes(end_at)})`
                ],
                color: is_between ? 'success-bold' : 'secondary',
                state: is_between
            }
        }
    }

    /**
     * État du blocage des accès
     * @param {PublicationInterface} publication - Publication
     * @returns {libelle: string; color: string; icon: string; state: boolean} Données à afficher sur l'interface
     */
    getBlocage(publication: PublicationInterface): {
        libelle: string,
        color: string,
        icon: string,
        state: boolean
    } {
        if (publication.opened === opened_datas.OPENED_OUI) {
            return { libelle: '', color: 'tertiary', icon: 'lock-open-alt', state: true }
        } else if (publication.opened === opened_datas.OPENED_NON) {
            return { libelle: '', color: 'danger', icon: 'lock-alt', state: false }
        }
        return { libelle: '-', color: 'secondary', icon: 'lock', state: false }
    }

    /**
     * État de publication
     * @param {PublicationInterface} publication - Publication
     * @returns {libelle: string; classe: string; icon: string; color: string} - Données à afficher sur l'interface
     */
    getEtat(publication: PublicationInterface): {
        libelle: string,
        classe: string,
        icon: string,
        color: string
    } {
        if (
            this.getEtatValidation(publication).state &&
            this.getProg(publication).state &&
            this.getProg(publication, 'visibility').state &&
            this.getBlocage(publication).state
        ) {
            return { libelle: 'PUBLIÉ', classe: 'bg_publier', icon: 'check', color: 'success-bold' }
        } else {
            return { libelle: 'NON PUBLIÉ', classe: 'bg_no_publier', icon: 'times', color: 'secondary' }
        }
    }

    /**
     * Style d'affichage de la ligne
     * @param {PublicationInterface} publication - Publication à traiter
     * @returns string - Classe CSS
     */
    getClasse(publication: PublicationInterface): string {
        if (
            publication.datas_transfered === etat_transfered_datas.DATAS_TRANSEFERED_OUI &&
            this.getProg(publication).color === 'success-bold' &&
            publication.opened === opened_datas.OPENED_OUI
        ) {
            return 'bg_publier'
        } else {
            return 'bg_no_publier'
        }
    }

    /**
     * Initialisation des datas
     */
    initDatas() {
        this.publications_inscriptions = this.$store.getters['publication/get_publications_inscriptions']
    }

    /**
     * Ouverture du popup d'édition d'une publication
     */
    openEditionPublication(publication: any) {
        this.publication_select.id = publication.id
        this.publication_select.name = publication.name
        this.publication_select.opened = publication.opened
        this.publication_select.publishable = publication.publishable
        this.publication_select.datas_transfered = publication.datas_transfered
        this.publication_select.datas_validated = publication.datas_validated

        if (publication.visibility_start_at && publication.visibility_end_at) {
            this.publication_select.visibility_start_at = convertDateLocalValeurT(publication.visibility_start_at)
            this.publication_select.visibility_end_at = convertDateLocalValeurT(publication.visibility_end_at)
        }
        if (publication.start_at && publication.end_at) {
            this.publication_select.start_at = convertDateLocalValeurT(publication.start_at)
            this.publication_select.end_at = convertDateLocalValeurT(publication.end_at)
        }
        this.inverse_switch = !this.publication_select.opened

        // Récupère les messages concernant le publishable sélectionné
        let messages: any = []
        if (this.$store.state.publishableMessage.publishableMessages.length === 0) {
            const params = { publishable_id: publication.publishable.id }
            this.$store.dispatch('publishableMessage/getPublishableMessages', params).then(() => {
                messages = this.$store.getters['publishableMessage/publishableMessages_by_pid'](
                    publication.publishable.id
                )
                this.publication_select.message = messages.find(
                    (m: any) => m.code === code_publishable_message.PUBLICATION_BLOQUEE
                )
            })
        } else {
            messages = this.$store.getters['publishableMessage/publishableMessages_by_pid'](publication.publishable.id)
            this.publication_select.message = messages.find(
                (m: any) => m.code === code_publishable_message.PUBLICATION_BLOQUEE
            )
        }

        this.showModaleEditionAcces = true
    }

    /**
     * Sauvegarde l'édition des accès d'une publication
     */
    saveEditionPublication() {
        this.error_dates = null
        this.$store.commit('publication/SET_LOADING', true)
        this.publication_select.opened = this.inverse_switch ? 0 : 1
        const payload = JSON.parse(JSON.stringify(this.publication_select))
        if (payload.visibility_start_at && payload.visibility_end_at) {
            payload.visibility_start_at = convertDateUTCValeurT(payload.visibility_start_at)
            payload.visibility_end_at = convertDateUTCValeurT(payload.visibility_end_at)
        }
        if (payload.start_at && payload.end_at) {
            payload.start_at = convertDateUTCValeurT(payload.start_at)
            payload.end_at = convertDateUTCValeurT(payload.end_at)
        }

        if (
            (payload.start_at && payload.end_at) ||
            (!payload.start_at && !payload.end_at) ||
            (payload.visibility_start_at && payload.visibility_end_at) ||
            (!payload.visibility_start_at && !payload.visibility_end_at)
        ) {
            this.$store
                .dispatch('publication/updatePublication', {
                    publication_id: this.publication_select.id,
                    payload: payload
                })
                .then(() => {
                    this.closeEditionPublication()
                })
        } else {
            // Formulaire de dates incorrect
            this.error_dates = "Vous devez renseigner la date d'ouverture et la date de fermeture."
        }
    }

    /**
     * Ferme la popup d'édition des accès d'une publication
     */
    closeEditionPublication() {
        this.showModaleEditionAcces = false
        this.publication_select = JSON.parse(JSON.stringify(this.publication_template))
    }

    /**
     * Relance la validation des données vers le portail
     */
    retryValidateDatas(publication_id: number) {
        this.$store.dispatch('publication/retryValidateDatas', publication_id).then(() => {
            this.initDatas()
        })
    }

    mounted() {
        this.$store.dispatch('publication/getPublications').then(() => {
            this.initDatas()
        })
    }
}
